"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.statisticsNovoDark = exports.statisticsNovo = exports.statistics = exports.cardNovoDark = exports.cardNovo = exports.card = void 0;
const oxygen_theme_1 = __importDefault(require("@8x8/oxygen-theme"));
const color_const_1 = __importDefault(require("../choices/color.const"));
const size_const_1 = __importDefault(require("../choices/size.const"));
const font_const_1 = __importDefault(require("../choices/font.const"));
const spacing_const_1 = __importDefault(require("../choices/spacing.const"));
const { novo, novoDark } = oxygen_theme_1.default;
const card = {
    cardHeight: '252px',
    cardWidth: '328px',
    cardBackground: color_const_1.default.white,
    cardBoxShadow: `${size_const_1.default.shadowMedium} ${color_const_1.default.cloudyBlue300}`,
    cardBorderTop: `6px solid ${color_const_1.default.celadonBlue}`,
    cardBorderRadius: `${size_const_1.default.borderRadiusMedium} ${size_const_1.default.borderRadiusMedium} 0 0`,
    cardHeaderFontWeight: font_const_1.default.weightAttention,
    cardHeaderFontSize: font_const_1.default.sizeMd,
    cardHeaderLineHeight: font_const_1.default.lineHeightSm,
    cardHeaderColor: color_const_1.default.pickledBluewood800,
    cardSeparatorBackgroundColor: color_const_1.default.cloudyBlue300,
    cardSeparatorHeight: '1px',
    cardSeparatorWidth: '100%',
};
exports.card = card;
const cardNovo = {
    cardHeight: '252px',
    cardWidth: '328px',
    cardBackground: novo.ui06,
    cardBoxShadow: novo.shadowMedium,
    cardSeparatorHeight: '1px',
    cardSeparatorWidth: '100%',
    cardBorder: `1px solid ${novo.ui01}`,
    cardBorderTop: `1px solid ${novo.ui01}`,
    cardBorderRadius: '0px',
    cardHeaderFontWeight: novo.heading01.fontWeight,
    cardHeaderFontSize: novo.heading01.fontSize,
    cardHeaderLineHeight: novo.heading01.lineHeight,
    cardHeaderColor: novo.textColor01,
    cardSeparatorBackgroundColor: novo.ui01,
};
exports.cardNovo = cardNovo;
const cardNovoDark = {
    ...cardNovo,
    cardBackground: novoDark.ui06,
    cardBoxShadow: novoDark.shadowMedium,
    cardBorder: `1px solid ${novoDark.ui01}`,
    cardBorderTop: `1px solid ${novoDark.ui01}`,
    cardHeaderColor: novoDark.textColor01,
    cardSeparatorBackgroundColor: novoDark.ui01,
};
exports.cardNovoDark = cardNovoDark;
const statistics = {
    numbersFontWeight: font_const_1.default.weightAttention,
    numbersFontSize: font_const_1.default.sizeMd,
    numbersLineHeight: font_const_1.default.lineHeightMd,
    numbersColorError: color_const_1.default.coral,
    textFontSize: font_const_1.default.sizeXs,
    textLineHeight: font_const_1.default.lineHeightXs,
    textColor: color_const_1.default.steel700,
    textColorError: color_const_1.default.coral,
    boxMargin: `${spacing_const_1.default.md} ${spacing_const_1.default.lg} ${spacing_const_1.default.lg}`,
    boxWidth: '70px',
};
exports.statistics = statistics;
const statisticsNovo = {
    numbersFontWeight: novo.heading01.fontWeight,
    numbersFontSize: novo.heading01.fontSize,
    numbersLineHeight: novo.heading01.lineHeight,
    numbersColor: novo.textColor01,
    numbersColorError: novo.error01,
    textFontSize: novo.body01.fontSize,
    textLineHeight: novo.body01.lineHeight,
    textColor: novo.textColor01,
    textColorError: novo.error01,
    boxMargin: `${novo.spacing05} ${novo.spacing06} ${novo.spacing06}`,
    boxWidth: '70px',
};
exports.statisticsNovo = statisticsNovo;
const statisticsNovoDark = {
    ...statisticsNovo,
    numbersColor: novoDark.textColor01,
    numbersColorError: novoDark.error01,
    textColor: novoDark.textColor01,
    textColorError: novoDark.error01,
};
exports.statisticsNovoDark = statisticsNovoDark;
